import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  getAllModules,
  getModulesInArea,
  putAddModuleArea,
} from "../../../api/area";
import ButtonNextLevel from "../../signin/buttonNextLevel";

export default function LevelThreeArea({
  level,
  setLevel,
  areaId,
  setModuleSelected,
  moduleSelected,
  update,
}) {
  const [dataModules, setDataModules] = useState();
  let Array = [];
  // useEffect(() => {
  //   if (moduleSelected) {
  //     Array = moduleSelected;
  //   }
  // }, [moduleSelected]);
  // console.log(Array);
  // console.log(Array);
  useEffect(() => {
    getAllModules()
      .then((x) => {
        setDataModules(x);
        // let Array = x.map((item) => item.id);
      })
      .catch(() => {});
  }, []);
  useEffect(() => {
    if (areaId) {
      getModulesInArea(areaId)
        .then((x) => setModuleSelected(() => x.map((item) => item.moduleId)))
        .catch(() => {});
    }
  }, [areaId]);
  useEffect(() => {
    if (moduleSelected) {
      // if (update) {
      //   moduleSelected?.map((x) => {
      //     if (x !== "" && x !== undefined) {
      //       Array.push(x.id);
      //     }
      //   });
      // } else {
      moduleSelected?.map((x) => {
        if (x !== "" && x !== undefined) {
          Array.push(x);
        }
      });
    }
    // }
  }, [moduleSelected]);
  console.log(Array);
  console.log(moduleSelected);
  // console.log(dataModules);
  return (
    <>
      <Box
        height="55vh"
        sx={{ overflow: "auto" }}
        p="5px"
        display="flex"
        gap="20px"
        flexWrap={"wrap"}
      >
        {dataModules?.map((x, i) => (
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            width="150px"
            height="110px"
            bgcolor={"#F5F9FF"}
            boxShadow={"0px 2px 4px 0px #00000040"}
            borderRadius="13px"
            border={
              //   ? "solid 3px var(--emr-darkblue)"
              //   : "solid 3px #F5F9FF"
              moduleSelected[i] === x.id ||
              moduleSelected.some((mod) => mod === x.id)
                ? "solid 3px var(--emr-darkblue)"
                : "solid 3px #F5F9FF"
            }
            sx={{ cursor: "pointer", transition: "0.3s all" }}
            onClick={(e) => {
              // setModuleSelected((z) => {
              //   let array = [...z];
              //   array[i] !== x.id ? (array[i] = x.id) : (array[i] = "");
              //   // console.log(array);
              //   return array;
              // });
              setModuleSelected((z) => {
                let array = [...z];

                if (array.includes(x.id)) {
                  // اگر آیتم از قبل وجود داشته باشد، حذفش کن
                  array = array.filter((id) => id !== x.id);
                } else {
                  // اگر آیتم وجود نداشت، آن را اضافه کن
                  array.push(x.id);
                }

                return array;
              });
              // console.log(x);
            }}
          >
            <Typography
              color={
                moduleSelected[i] === x.id ||
                moduleSelected.some((mod) => mod?.moduleId === x.id)
                  ? "var(--emr-darkblue)"
                  : "#909090"
              }
              fontWeight="bold"
            >
              {x.name}
            </Typography>
          </Box>
        ))}
      </Box>
      <Box display="flex" justifyContent={"end"}>
        <ButtonNextLevel
          setLevel={setLevel}
          level={level}
          onClickNextLevel={() => {
            // if (update) {
            //   putAddModuleArea(areaId, dataModules)
            //     .then(() => setLevel(4))
            //     .catch(() => {});
            // } else {
            putAddModuleArea(areaId, Array)
              .then(() => setLevel(4))
              .catch(() => {});
            // }
          }}
        />
      </Box>
    </>
  );
}
